import FooterDesktop from "./FooterDesktop"
import FooterAccordion from "./FooterAccordion"
import { usePageContext } from "vike-react/usePageContext"

export default function Footer() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')
  
  const shouldHide = currentPath?.startsWith('/admin') ||
                    (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'))
  
  if (shouldHide) return null
  
  return <div className="z-10">
    <FooterDesktop />
    <FooterAccordion />
  </div>
}
